import { pdf } from "@react-pdf/renderer";

/**
 * Generate a PDF blob from a React PDF document
 * @param {React.Element} pdfDocument - The PDF document element
 * @returns {Promise<Blob>} The generated PDF blob
 */
export const generatePDFBlob = async (pdfDocument) => {
  return await pdf(pdfDocument).toBlob();
};

/**
 * Convert a blob to base64 string
 * @param {Blob} blob - The blob to convert
 * @returns {Promise<string>} The base64 string (without data URL prefix)
 */
export const blobToBase64 = async (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]); // Remove data prefix
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

/**
 * Download a blob as a file
 * @param {Blob} blob - The blob to download
 * @param {string} filename - The filename for the download
 */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  // Trigger download
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
